
      import Pen from './pen.vue'
      import type { App, Plugin } from 'vue'

      export const PenPlugin: Plugin = {
        install(app: App) {
          app.component('Pen', Pen)
        },
      }
      export { Pen }
      